export default __webpack_public_path__ + "static/media/pasotres.040b4edf.png";